
import axios from "axios";
import { API_URL, apiConfig } from "@/utils/api";

export const customerService = {
    getCustomers: async (segment = "", search = "") => {
        const response = await axios.get(`${API_URL}/admin/customers`, {
            params: { segment, search },
            ...apiConfig
        });
        return response.data;
    },

    getCustomerDetail: async (phone) => {
        const response = await axios.get(`${API_URL}/admin/customers/${phone}`, apiConfig);
        return response.data;
    },

    deleteDataGDPR: async (phone) => {
        const response = await axios.delete(`${API_URL}/admin/customers/${phone}/gdpr`, apiConfig);
        return response.data;
    },

    getAnalytics: async () => {
        const response = await axios.get(`${API_URL}/admin/analytics/dashboard`, apiConfig);
        return response.data;
    }
};

export const marketingService = {
    getCoupons: async () => {
        const response = await axios.get(`${API_URL}/admin/coupons`, apiConfig);
        return response.data;
    },

    createCoupon: async (data) => {
        const response = await axios.post(`${API_URL}/admin/coupons`, data, apiConfig);
        return response.data;
    },

    validateCoupon: async (code, phone = "") => {
        const response = await axios.post(`${API_URL}/admin/coupons/validate`, { code, phone }, apiConfig);
        return response.data;
    }
};
